import axios from "axios";
import { getAuthHeader } from "./utils";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function fetchCongressMemberByBioguideId(bioguideId) {
  const response = await axios.get(
    `${API_BASE_URL}/api/congress/member/${encodeURIComponent(bioguideId)}/`
  );
  return response.data;
}

export async function fetchMultipleCongressMembers(bioguideIds) {
  const uniqueIds = [...new Set((bioguideIds || []).filter(Boolean))];
  const members = await Promise.all(
    uniqueIds.map(async (bioguideId) => {
      const member = await fetchCongressMemberByBioguideId(bioguideId);
      return [bioguideId, member];
    })
  );
  return Object.fromEntries(members);
}

export async function fetchCallCounts(bioguideIds, billId = null) {
  if (!bioguideIds || bioguideIds.length === 0) return {};
  const headers = await getAuthHeader();
  const body = { bioguide_ids: bioguideIds };
  if (billId) {
    body.bill_id = billId;
  }
  const response = await axios.post(
    `${API_BASE_URL}/api/calls/counts/`,
    body,
    { headers }
  );
  return response.data || {};
}

export async function logCallOutcome({
  billId,
  billType,
  billNumber,
  repBioguideId,
  outcome,
  callMode = "intent",
}) {
  const headers = await getAuthHeader();
  const response = await axios.post(
    `${API_BASE_URL}/api/calls/log-outcome/`,
    {
      bill_id: billId,
      bill_type: billType,
      bill_number: billNumber,
      rep_bioguide_id: repBioguideId,
      outcome,
      call_mode: callMode,
      contact_method: "call",
      timestamp: new Date().toISOString(),
    },
    { headers }
  );
  return response.data;
}

export async function logMessageOutcome({
  billId,
  billType,
  billNumber,
  repBioguideId,
}) {
  const headers = await getAuthHeader();
  const response = await axios.post(
    `${API_BASE_URL}/api/calls/log-outcome/`,
    {
      bill_id: billId,
      bill_type: billType,
      bill_number: billNumber,
      rep_bioguide_id: repBioguideId,
      contact_method: "message",
      outcome: "sent",
      timestamp: new Date().toISOString(),
    },
    { headers }
  );
  return response.data;
}
